import styled from 'styled-components';

export const Button = styled.button`
  && {
    all: unset;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: fit-content;
    padding: 0.5rem 0.75rem;
    border-radius: 39px;
    background: #303f4b;
    color: #ecf0f3;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    transition: background-color 0.2s ease, transform 0.2s ease;

    svg {
      width: 1rem;
      height: 1rem;
      color: #ec6643;
      flex-shrink: 0;
    }

    &:hover {
      background: #24333f;
    }

    &:active {
      transform: translateY(1px);
    }

    &:focus-visible {
      outline: 2px solid #ec6643;
      outline-offset: 2px;
    }
  }
`;
